import useExtendedRouter from "./useExtendedRouter";

export default useExtendedRouter;
